import { defineComponent as B, computed as E, useAttrs as O, openBlock as b, createBlock as S, unref as z, normalizeStyle as $, normalizeClass as g, withCtx as v, createElementVNode as P, mergeProps as R, renderSlot as C, normalizeProps as w, guardReactiveProps as y, createElementBlock as A, createCommentVNode as H } from "vue";
import "@popperjs/core";
import { RevPopover as I } from "@ds/components/Popover";
import { omit as M } from "../../utils/omit.js";
import { tw as t } from "../../utils/tailwind.js";
const F = /* @__PURE__ */ B({
  name: "RevTooltip",
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    contentClassNames: { default: "" },
    modifiers: { default: void 0 },
    position: { default: "top" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 },
    withCaret: { type: Boolean, default: !0 },
    alignment: { default: "center" }
  },
  setup(r) {
    const i = r, x = E(() => M(O(), ["class", "style"])), k = (o) => {
      const l = o.split("-", 1)[0], e = i.withCaret ? {
        top: t`mb-8`,
        bottom: t`mt-8`,
        left: t`mr-8`,
        right: t`ml-8`
      }[l] : "", a = {
        left: t`text-left`,
        center: t`text-center`
      }[i.alignment];
      return [
        t`bg-overlap-default-low text-static-default-mid mood-inverse rounded-sm body-2 relative inline-block max-w-224 px-16 py-12`,
        e,
        a,
        i.contentClassNames
      ];
    }, N = (o) => {
      if (!i.withCaret)
        return "";
      const l = t`border-t-overlap-default-low -bottom-6 border-t-6`, e = t`border-b-overlap-default-low -top-6 border-b-6`, a = t`border-l-overlap-default-low -right-6 border-l-6`, d = t`border-r-overlap-default-low -left-6 border-r-6`, s = t`border-x-6 border-solid border-x-transparent`, c = t`left-[calc(50%-6px)]`, m = t`left-12`, u = t`left-[calc(100%-12px)]`, n = t`border-y-6 border-solid border-y-transparent`, p = t`top-[calc(50%-6px)]`, f = t`top-12`, h = t`top-[calc(100%-12px)]`;
      return [
        t`absolute`,
        {
          top: [l, s, c],
          "top-start": [l, s, m],
          "top-end": [l, s, u],
          bottom: [e, s, c],
          "bottom-start": [e, s, m],
          "bottom-end": [e, s, u],
          left: [a, n, p],
          "left-start": [a, n, f],
          "left-end": [a, n, h],
          right: [d, n, p],
          "right-start": [d, n, f],
          "right-end": [d, n, h]
        }[o]
      ];
    };
    return (o, l) => (b(), S(z(I), {
      class: g(o.$attrs.class),
      "content-class-names": "w-max",
      modifiers: r.modifiers,
      position: r.position,
      "should-hide-on-click-outside": r.shouldHideOnClickOutside,
      "should-show-on-mount": r.shouldShowOnMount,
      style: $(o.$attrs.style),
      "trigger-element-id": r.triggerElementId
    }, {
      trigger: v((e) => [
        C(o.$slots, "trigger", w(y(e)))
      ]),
      content: v((e) => [
        P("div", R(x.value, {
          class: k(e.position)
        }), [
          C(o.$slots, "default", w(y(e))),
          r.withCaret ? (b(), A("div", {
            key: 0,
            class: g(N(e.position)),
            "data-popper-arrow": ""
          }, null, 2)) : H("", !0)
        ], 16)
      ]),
      _: 3
    }, 8, ["class", "modifiers", "position", "should-hide-on-click-outside", "should-show-on-mount", "style", "trigger-element-id"]));
  }
});
export {
  F as default
};
